import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage or default to English
    // Safely check if localStorage is available
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return localStorage.getItem('haros-language') || 'en';
      }
    } catch (e) {
      console.warn('localStorage not available:', e);
    }
    return 'en';
  });

  useEffect(() => {
    // Safely set localStorage
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('haros-language', language);
      }
    } catch (e) {
      console.warn('Could not save to localStorage:', e);
    }
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
